import { useClipboard } from '@chakra-ui/react';
import { useCallback } from 'react';
import { Paragraph, TextLink, useSnackbar } from 'ui-components';
import { routes } from '~/core/router';
import { SITE_URL, humanizeDate } from '~/utils';

export function PlatformChartsCaptionLastUpdatedWithReconnectText({
  demographicsLastUpdatedAt,
}: {
  demographicsLastUpdatedAt?: string;
}) {
  const { onCopy } = useClipboard(`${SITE_URL}${routes.connectionDashboard}`);
  const snackbar = useSnackbar();

  const onClick = useCallback(() => {
    onCopy();
    snackbar.success({ description: 'Link copied to clipboard' });
  }, [onCopy, snackbar]);

  return (
    <Paragraph sx={{ marginTop: 'spacing-200' }} size="sm" color="primary.300">
      Last updated {humanizeDate(demographicsLastUpdatedAt)}.{' '}
      <TextLink size="sm" onClick={onClick}>
        Copy talent reconnection link
      </TextLink>
    </Paragraph>
  );
}
